import { Component, input } from '@angular/core';
import { IconComponent } from '@kin/spark-ui';
import { SignupLoaderComponent } from './signup-loader.component';

/** Full-width submit button + reassurance line; must sit inside the parent <form>. */
@Component({
  selector: 'app-form-cta',
  standalone: true,
  imports: [IconComponent, SignupLoaderComponent],
  template: `
    @if (error()) { <p class="submit-error" role="alert">{{ error() }}</p> }
    <button type="submit" class="cta" [class.unavailable]="disabled()" [disabled]="submitting() || disabled()">
      @if (submitting()) {
        <app-signup-loader>{{ submittingLabel() }}</app-signup-loader>
      } @else {
        <span>{{ label() }}</span>
        <ngk-icon [icon]="icon()" size="20px" />
      }
    </button>
    <div class="reassurance">
      <ngk-icon icon="lock" size="12px" /><span>{{ reassurance() }}</span>
    </div>
  `,
  styles: `
    :host { display: block; }
    /* Solid Yellow-600 CTA with Neutral-1000 text (12.20:1); hover goes lighter per Kin button spec */
    .cta {
      width: 100%; padding: 16px 24px; font-size: 16px; font-weight: 600; font-family: inherit;
      color: var(--kin-neutral-1000); background: var(--kin-yellow-600); border: 0; border-radius: var(--kin-radius-pill);
      cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px;
      transition: background 180ms var(--kin-ease-out), transform 100ms ease;
    }
    .cta:not(:disabled):hover { background: var(--kin-yellow-400); }
    .cta:not(:disabled):active { transform: scale(0.985); background: var(--kin-yellow-700); }
    .cta:focus-visible { outline: none; box-shadow: var(--kin-shadow-focus); }
    .cta:disabled { cursor: default; opacity: 0.6; }
    /* Not available yet (vs. submitting): neutral, so it doesn't read as the next step */
    .cta.unavailable { cursor: not-allowed; opacity: 1; color: var(--kin-neutral-600); background: var(--kin-neutral-200); }
    .cta app-signup-loader { color: inherit; }
    .submit-error { color: var(--kin-red-600); font-size: 14px; font-weight: 500; margin: 0 0 12px; text-align: center; }
    .reassurance {
      display: flex; align-items: center; justify-content: center; gap: 8px;
      margin-top: 14px; font-size: 12px; color: var(--kin-text-tertiary);
    }
  `,
})
export class FormCtaComponent {
  readonly label = input.required<string>();
  readonly submittingLabel = input.required<string>();
  readonly icon = input('arrow-right');
  readonly reassurance = input.required<string>();
  readonly submitting = input(false);
  /** Not available yet, e.g. enrolling before Form 50-162 is signed. */
  readonly disabled = input(false);
  readonly error = input('');
}
